import { render, staticRenderFns } from "./FounderConsultList.vue?vue&type=template&id=bfe6aa18&scoped=true&"
import script from "./FounderConsultList.vue?vue&type=script&lang=ts&"
export * from "./FounderConsultList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe6aa18",
  null
  
)

export default component.exports